// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { DistributedTracingModes } from '@microsoft/applicationinsights-web';
import packageJson from '../../package.json';
import { Environment } from '../app/models/environment';

export const environment: Environment = {
  production: false,
  version: packageJson.version,
  clientId: '838559c3-6bf8-435e-9558-e54663d7faba', // clientId is not a secret
  provider: 'https://fedauth.qa.alaskasworld.com',
  appInsightsConfig: {
    // this is not secret, it is only inserted dynamically for disaster recovery scenarios when a new application insights instance is created via the CI/CD pipeline
    connectionString: '',
    distributedTracingMode: DistributedTracingModes.W3C,
    disableFetchTracking: false,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
  },
  acknowledgeTimeout: 10,
  bluefinConfig: {
    baseUrl: 'https://secure-cert.shieldconex.com',
    templateId: '0ac74667f54f8167a96904de20211e0e',
  },
  iCargoBaseUrlRedirect: 'https://asstg-icargo.ibsplc.aero/icargo/cashiering.defaults.paymentgateway.closepaymentgatewaycommand.do',
  //Number of attempts to get manual payment token (Bluefin)
  //the interval of each attempt is 5 secs, so for 10 minutes
  //it's 60/5*10=120 (60 secs(1 min)/interval*total minutes)
  //
  manualPaymentAttempts: 120,
};
